export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/julia/Desktop/kinfolk/src/environments/environment.ts